/*
20250430
本命のみの場合エラーになる。
result['ccba']= new Array(6);
上記の代入ではどうもうまく配列にならないようで、
今後は空の場合0（ゼロ）を代入しておくことにする。
それに伴い、
chartData.js側は、
if分を追加した。
*/
// 画像の_2消さない
result = new Array();
result['aaaa']= new Array(1,3,7);
result['aaab']= new Array(3,1,6);
result['aaba']= new Array(1,3,7);
result['aabb']= new Array(3,1,6);
result['abaa']= new Array(3,4,5);
result['abab']= new Array(3,1,6);
result['abba']= new Array(3,4,5);
result['abbb']= new Array(3,1,6);
result['acaa']= new Array(6,3);
result['acab']= new Array(3,6,1);
result['acba']= new Array(6,3);
result['acbb']= new Array(3,6,1);
result['baaa']= new Array(1,7,2);
result['baab']= new Array(1,4,7);
result['baba']= new Array(1,7,2);
result['babb']= new Array(1,4,7);
result['bbaa']= new Array(4,5,3);
result['bbab']= new Array(4,1,6);
result['bbba']= new Array(4,5,3);
result['bbbb']= new Array(4,1,6);
result['bcaa']= new Array(6,4);
result['bcab']= new Array(6,4,1);
result['bcba']= new Array(6,4);
result['bcbb']= new Array(6,4,1);
result['caaa']= new Array(7,1,2);
result['caab']= new Array(7,5,1);
result['caba']= new Array(7,1,2);
result['cabb']= new Array(7,5,1);
result['cbaa']= new Array(5,4,3);
result['cbab']= new Array(5,7,2);
result['cbba']= new Array(5,4,3);
result['cbbb']= new Array(5,7,2);
result['ccaa']= new Array(6,0,0,0);
result['ccab']= new Array(5,6,7);
result['ccba']= new Array(6,0,0,0);
result['ccbb']= new Array(5,6,7);
result['daaa']= new Array(2,7,1);
result['daab']= new Array(2,5,7);
result['daba']= new Array(2,7,1);
result['dabb']= new Array(2,5,7);
result['dbaa']= new Array(5,2,7);
result['dbab']= new Array(2,5,7);
result['dbba']= new Array(5,2,7);
result['dbbb']= new Array(2,5,7);
result['dcaa']= new Array(6,0,0,0);
result['dcab']= new Array(5,2);
result['dcba']= new Array(6,0,0,0);
result['dcbb']= new Array(5,2);


/*結果表示時の画像Altのために*/

batAlt = new Array();
batAlt[1] = 'BIGBANGSHOT';
batAlt[2] = 'BIGBANGSHOT GB';
batAlt[3] = 'ZettPower HB';
batAlt[4] = 'ZettPower';
batAlt[5] = 'ZettPower GB';
batAlt[6] = 'GODA-F 2740';
batAlt[7] = 'NEOSTATUS';

//ga引き渡し用の文字列
gaHiki = new Array();
gaHiki[1] = new Array();
gaHiki[1][0] = 'バッティングタイプ';
gaHiki[1]['a'] = '長距離打者';
gaHiki[1]['b'] = '中距離打者';
gaHiki[1]['c'] = '短距離打者';

gaHiki[2] = new Array();
gaHiki[2][0] = 'バットバランス';
gaHiki[2]['a'] = 'ヘッドバランス';
gaHiki[2]['b'] = 'ミドルヘッドバランス';
gaHiki[2]['c'] = 'ミドルニアバランス';
gaHiki[2]['d'] = 'ニアバランス';

gaHiki[3] = new Array();
gaHiki[3][0] = '打球感';
gaHiki[3]['a'] = '柔らかい打球感で乗せて運ぶ';
gaHiki[3]['b'] = '柔らかく吸い付き最後に強く弾く';
gaHiki[3]['c'] = '硬い打球感で強く弾く';

gaHiki[4] = new Array();
gaHiki[4][0] = 'サイズ';
gaHiki[4]['a'] = '84cm';
gaHiki[4]['b'] = '83cm';

gaHiki[5] = new Array();
gaHiki[5][0] = '打撃スタイル';
gaHiki[5]['a'] = '打球感重視';
gaHiki[5]['b'] = 'バランス重視';



/*
回答のすべての組み合わせをchartData.jsに連想配列として定義。
　※chartData.jsは二宮のローカルマシンにDB.xlsとしてエクセルにて制作。
　　一旦csvにて書き出し、それを置換してJavaScriptの連想配列として精製。
回答する毎に?acbbbのように引数が付け足される。
　※戻って修正した場合は引数も最後尾が削除される
その引数を最終結果であるresult.htmlにて処理。
result['bdaab']= new Array(2,7,5);
のような連想配列のkeyとしてそのまま使用する。
new Array(2,7,5);
の部分は、本命、推奨、推奨の順に並んでいるのでそのままの並びで掲載。
おしまい。
*/

$(function() {
	qnum = '';
	hiki = '';

	//URL取得
	var url   = location.href;
	params = url.split("?");
	if(params[1]){
		hiki = params[1];
	}else{
		hiki = '';
	}
	//ページナンバー代入
	pNum = $('body').attr('data-pNum');

	//設問3のみボタン表示をコントロール
	//20220926-全組み合わせを見せる事にしたのでキャンセル
	/*if(pNum == 3){
		key = params[1].slice(-1);
		hdnBtnAr = new Array();
		if(key == 'a'){
			hdnBtnAr = Array('a','c');
		}else if(key == 'b'){
				hdnBtnAr = Array();
		}else if(key == 'c'){
				hdnBtnAr = Array('a','c');
		}else if(key == 'd'){
				hdnBtnAr = Array('b');
		}
		$(".qBtn").each(function(){
			for(i=0; i<hdnBtnAr.length; i++){
				if($(this).attr('data-qnum') == hdnBtnAr[i]){
					$(this).addClass('hdn');
				}
			}
		});
	}*/

	//設問選択
	$('.qBtn').click(function(){
		qnum = '';
		qnum += $(this).attr('data-qnum');
		//選択中のボタン処理
		$(".qBtn").each(function(){
			$(this).removeClass('current');
		});
		$(this).toggleClass('current');
	});

	//次へクリックしたら
	$('.nextBtn').click(function(){
		if(!qnum){
			alert('回答を選択してください');//未選択の場合のエラー文言
		}else{
			//alert(gaHiki[pNum][0]+':'+gaHiki[pNum][qnum]);
			gtag('event','設問選択',{ 'event_category':gaHiki[pNum][0],'event_label':gaHiki[pNum][qnum] });
			//gtag('event','設問選択',{'questionno':'設問番号','answer':'解答'});
			nextURL = $(this).attr('data-nexturl');
			location.href= nextURL+'?'+hiki+qnum;
		}
	});

	//戻るボタン
	$('.prevBtn').click(function(){
		hiki = hiki.slice( 0, -1 ) ;//引数の最後尾を削除して戻す
		prevURL = $(this).attr('data-prevurl');
		location.href= prevURL+'?'+hiki;
	});

	//resultの処理
	//chartData.jsに連想配列で定義してあるので、そこから該当の値を取得して処理
	/*
	20250430
	本命のみの場合エラーになる。
	result['ccba']= new Array(6);
	上記の代入ではどうもうまく配列にならないようで、
	今後は空の場合0（ゼロ）を代入しておくことにする。
	それに伴い、
	chartData.js側は、
	if分を追加した。
	*/
	kaki = '';
	if(params[0].indexOf('result') != -1){
		key = params[1].substr(0,5);
		for(i = 0; i < result[key].length; i++){			
			if(result[key][i]){/*20250425*/
				if(i == 0){
					kaki += '<div class="resultBat honmei"><a href="#modal0'+result[key][i]+'" class="modal0'+result[key][i]+'" target="_blank"><img src="https://cdn.shopify.com/s/files/1/0611/4430/1664/files/bat_result_img0'+result[key][i]+'_2.png" alt="'+batAlt[result[key][i]]+'"></a></div>';
				}else{
					kaki += '<div class="resultBat suisyo"><a href="#modal0'+result[key][i]+'" class="modal0'+result[key][i]+'" target="_blank"><img src="https://cdn.shopify.com/s/files/1/0611/4430/1664/files/bat_result_img0'+result[key][i]+'_2.png" alt="'+batAlt[result[key][i]]+'"></a></div>';
				}
			}
		}
		$('.resultBox').html(kaki);
	}
});
